import { createContainer } from '@dbk-legacy/muster/react';
import CalendarModal from './calendar-modal';
import property from 'lodash/fp/property';

export default createContainer({
  $fragments: {
    calendarModal: {
      modal: {
        visible: true,
        onDone: { $call: 'done' },
      },
      calendar: {
        selectingDate: true,
        onSelectingDateChanged: { $set: 'selectingDate' },
        fromDate: true,
        toDate: true,
        onSelectDate: { $call: 'selectDate' },
      },
    },
  },
}, property('calendarModal'))(CalendarModal);
